import * as React from 'react';
import type { SVGProps } from 'react';
const SvgText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="#787887"
      d="M13.5 0c.25 0 .5.25.5.5V3c0 .281-.25.5-.5.5H13a.494.494 0 0 1-.5-.5V2H8v10.5h1.5c.25 0 .5.25.5.5v.5c0 .281-.25.5-.5.5h-5a.494.494 0 0 1-.5-.5V13c0-.25.219-.5.5-.5H6V2H1.5v1c0 .281-.25.5-.5.5H.5A.494.494 0 0 1 0 3V.5C0 .25.219 0 .5 0z"
    />
  </svg>
);
export default SvgText;
